import { useSessionStorageState } from '@olxpwa-lib/data-layer/session-storage';
import { useHostProps } from '~features/host-props';
import { AppEnvironment } from '~types';

export function useE2EMode() {
  const { env } = useHostProps();
  const [e2eMode] = useSessionStorageState('__e2e_mode__', false);

  return env !== AppEnvironment.Production && e2eMode;
}
